// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"163":"MobileAppPage","383":"SalePage"}[chunkId] || chunkId) + "." + {"163":"df863dc8","212":"4e0b334f","383":"87c0ba6e"}[chunkId] + ".js";
};